module.exports = __webpack_public_path__ + "img/avatar.585d29c6.svg";